import Typewriter from "typewriter-effect";
import "../styles/style.css";


function Text() {
    return (
        <Typewriter
            options={{
                strings: [
                    "Frontend",
                    "Python",
                    "PHP"
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 30,
                wrapperClassName: 'typewriter-wrapper'}}
        />
    )
}

export default Text